export const CONFIRMATION_FORM_TEXTS = {
  RETRY_BUTTON_LABEL: 'Получить новый код',
  RETRY_AVAILABLE_AFTER_LABEL: 'Получить новый код можно через',
  SUBMIT_BUTTON_LABEL: 'Отправить',
} as const;

export const TECHNICAL_ERROR_TEXT = 'Техническая ошибка. Попробуйте позднее';
export const TOO_MANY_REQUEST_ERROR_TEXT = 'Слишком много попыток. Попробуйте позднее.';
export const SMS_CODE_ERROR_TEXT = 'Неверный код';
